import { render, staticRenderFns } from "./CategoryComponentCategory.vue?vue&type=template&id=1b495c37&scoped=true&"
import script from "./CategoryComponentCategory.vue?vue&type=script&lang=js&"
export * from "./CategoryComponentCategory.vue?vue&type=script&lang=js&"
import style0 from "./CategoryComponentCategory.vue?vue&type=style&index=0&id=1b495c37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/katonobo/Documents/Web App/dream-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b495c37",
  null
  
)

export default component.exports